import styled from "styled-components";

export default styled.div`
  display: inline-block;
  ${props =>
    props.isEndPicker ? "padding-left: 25px;" : "padding-right: 25px;"};
`;
